import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    if (this.closest('.gomitolo-page-product .product-details')) {
      this.querySelectorAll('p').forEach(this.#compactImageEnding);
    }
  }

  /**
   * Imported descriptions can end an image paragraph with blank lines. Remove
   * only that empty tail in the rendered DOM; keep text and its line breaks.
   * @param {HTMLParagraphElement} paragraph
   */
  #compactImageEnding(paragraph) {
    const trailing = [];
    let node = paragraph.lastChild;
    while (node && (node.nodeName === 'BR' || (node.nodeType === Node.TEXT_NODE && !node.textContent?.trim()))) {
      trailing.push(node);
      node = node.previousSibling;
    }
    if (node?.nodeName === 'IMG') {
      trailing.forEach((emptyNode) => emptyNode.parentNode?.removeChild(emptyNode));
    }
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
